var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-block K2Input"},[_c('el-date-picker',{attrs:{"value":_vm.value,"type":"date","placeholder":_vm.placeholder},on:{"input":_vm.handleInput}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }